<!-- Start Error 404 Area -->
<div class="error-404-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="notfound">
                <div class="notfound-bg">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>

                <h1>Notice!</h1>
                <h3>Maintainence</h3>
                <p>We are maintaining this page. It will be back soon.</p>
                <a routerLink="/sku-customer" class="default-btn">Go back</a>
            </div>
        </div>
    </div>
</div>
<!-- End Error 404 Area -->
